import clsx from 'clsx';
import { Avatar, Dropdown, Typography } from '@/components/common';
import { InboxListItem } from '@/interfaces/inbox';
import { EllipsisVerticalIcon } from 'lucide-react';
import { useRouter } from 'next/router';
import { usePathname } from 'next/navigation';
import { format } from 'date-fns';

interface Props {
	tableData: InboxListItem[];
	actions?: any[];
}

export const MobileInboxList: React.FC<Props> = ({ tableData, actions }) => {
	const router = useRouter();
	const pathname = usePathname();

	const onClickRow = (rowValue: InboxListItem, index: number): void => {
		router.push({
			pathname: `${pathname}/${rowValue.id}`,
			query: { page: 1, limit: 1, index },
		});
	};

	return (
		<div className="mt-4 block md:hidden">
			{tableData.map((row, index) => (
				<div
					key={index}
					className={clsx('py-2 px-4 border-t flex gap-2', {
						'bg-green-secondary rounded-2xl': !row?.is_read,
					})}
					onClick={() => onClickRow(row, index)}
				>
					<div>
						<Avatar
							firstname={row.firstname || ''}
							lastname={row.lastname || ''}
							photoUrl={row?.profile_picture || ''}
							size="small"
						/>
					</div>
					<div className="w-full">
						<div className="flex justify-between">
							<Typography
								type="regular-16"
								text={`${row?.firstname} ${row.lastname}`}
								className="font-semibold pt-1 pb-[10px]"
							/>
							<div className="flex items-center gap-2">
								<Typography
									type="regular-14"
									text={format(new Date(row.last_message_time), 'MMM d')}
									className={clsx('line-clamp-1 pb-1', {
										'font-semibold': !row?.is_read,
									})}
								/>
								{actions && actions.length > 0 && (
									<div onClick={(e) => e.stopPropagation()}>
										<Dropdown
											buttonContent={
												<EllipsisVerticalIcon className="w-6 h-6" />
											}
											showChevronDownIcon={false}
											items={actions.map((action) => ({ ...action, ...row }))}
										/>
									</div>
								)}
							</div>
						</div>
						<Typography
							type="regular-14"
							text={row?.subject}
							className={clsx('line-clamp-1 pb-1', {
								'font-semibold': !row?.is_read,
							})}
						/>
						<Typography
							type="regular-14"
							text={row?.case_name}
							className={clsx('opacity-60 line-clamp-1', {
								'font-semibold': !row?.is_read,
							})}
						/>
					</div>
				</div>
			))}
		</div>
	);
};
